import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, StatusBadge, Loading } from "@/components/common";
import { MusicNotes, Play, Plus, ShieldWarning } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Music() {
  const { data: music, loading } = useFetch("/music");
  if (loading || !music) return <Loading />;

  return (
    <div>
      <PageHeader icon={MusicNotes} title="Music & SFX Studio"
        subtitle="PinPilot themes, character & world themes, background music and the SFX library. Every asset stores licensing / provenance — never assume AI music is commercially usable."
        actions={<button data-testid="add-music" onClick={() => toast("Phase 2: generate music with the music provider.")}
          className="inline-flex items-center gap-2 rounded-full bg-magic px-4 py-2 text-sm font-semibold text-black"><Plus size={16} weight="bold" /> New Track</button>} />

      <Panel className="p-0 overflow-hidden">
        {music.map((m, i) => (
          <div key={m.id} data-testid={`music-${m.id}`} className={`flex items-center gap-4 p-4 ${i !== music.length - 1 ? "border-b border-white/5" : ""} hover:bg-white/[0.03] transition-colors`}>
            <button onClick={() => toast(`Play ${m.name} (Phase 2)`)} className="h-10 w-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:border-[#00E5FF]/40 transition-colors shrink-0"><Play size={16} weight="fill" /></button>
            <div className="min-w-0 flex-1">
              <div className="font-medium text-white">{m.name}</div>
              <div className="text-xs text-zinc-500">{m.type} · {m.duration}</div>
            </div>
            <div className="hidden sm:flex items-center gap-2 text-xs text-zinc-400">
              <ShieldWarning size={14} weight="duotone" className={m.license.startsWith("Unknown") ? "text-[#FFB800]" : "text-[#00FF9D]"} />
              <span className="max-w-[180px] truncate">{m.license}</span>
            </div>
            <span className="text-xs text-zinc-500 hidden md:block w-28 truncate">{m.provider}</span>
            <StatusBadge status={m.status} />
          </div>
        ))}
      </Panel>
    </div>
  );
}
